import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { useHistory } from "react-router-dom";
import { getPreApprovedAmount } from "../../../utils/helpers/get-pre-approved-amount";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { GA_EVENTS } from "./tracking";
import { BOOL_STATE } from "../../../constants/checkout-constants";
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { EXPERIMENT_TYPE } from "../../../constants/optimize-constants";

import Button from "../../shared/button";

const CarFinanceCdpBanner = ({
    preApproved,
    maxLoanAmount,
    firstName,
    pageSection,
    isPurposeBusiness,
    startPreApprovalOnFlyConnect,
    preApprovalOnFlyDesktop
}) => {
    const history = useHistory();
    const isCommercial = isPurposeBusiness === BOOL_STATE.YES;

    const handleGetPreApproval = () => {
        trackDesktopCustomEventsAU(GA_EVENTS.FINANCE_CARD_CLICKED, {
            ...GA_EVENTS.FINANCE_CARD_CLICKED_DETAILS
        });

        // Check A/B variant for pre-approval on-fly
        const isPreApprovalOnFlyVariant = getAbExpirementVariant(
            preApprovalOnFlyDesktop,
            EXPERIMENT_TYPE.VARIANT_B
        );

        if (isPreApprovalOnFlyVariant && startPreApprovalOnFlyConnect) {
            // VARIANT_B: Open pre-approval on-fly modal
            startPreApprovalOnFlyConnect({ entryPoint: "cdp-finance-banner", ctaText: "Continue Booking", refetchOnClose: true });
        } else {
            // CONTROL: Redirect to pre-approval page
            history.push("/financing/get-pre-approval");
        }
    };

    if (preApproved) {
        const displayName = firstName || "";
        const preApprovedAmount = getPreApprovedAmount(maxLoanAmount);

        return (
            <div className="container">
                <div styleName={"styles.outer"}>
                    <div styleName={"styles.rightColumn"}>
                        <img src={pageSection?.meta?.image} alt="Car Finance" />
                    </div>
                    <div styleName={"styles.leftColumn"}>
                        <p styleName={"styles.heading"}>
                            {displayName ? `${pageSection?.meta?.approvedText?.namePrefix} ${displayName}!` : "Congratulations!"}
                        </p>
                        {!isCommercial && <p styleName={"styles.subHeadingApproved"}>
                            {pageSection?.meta?.approvedText?.amountPrefix} <span>{preApprovedAmount}</span>
                        </p>}
                        {isCommercial && <p styleName={"styles.subHeadingApproved"}>
                            {pageSection?.meta?.approvedText?.businessAmountPrefix}
                        </p>}
                    </div>

                </div>
            </div>
        );
    }

    return (
        <div className="container">
            <div styleName={"styles.outer"}>
                <div styleName={"styles.rightColumn"}>
                    <img src={pageSection?.meta?.image} alt="Car Finance" />
                </div>
                <div styleName={"styles.leftColumn"}>
                    <p styleName={"styles.subHeading"}>{pageSection?.meta?.subheading || "Personalized rates on all cars"}</p>
                    <p styleName={"styles.heading"}>{pageSection?.meta?.heading}</p>
                    {/* <p styleName={"styles.subHeading"}><img src={handshakeIcon} alt="No impact" /> No impact on credit score</p> */}
                    <div styleName={"styles.features"}>
                        {pageSection?.meta?.valueProps?.map((item, index) => (
                            <div styleName={"styles.featureItem"} key={index}>
                                {item}
                            </div>
                        ))}
                    </div>

                </div>
                <div styleName={"styles.actionButtonWrapper"}>
                    <Button
                        onClick={handleGetPreApproval}
                        text={pageSection?.meta?.cta?.text}
                        variant="primary"
                        size="large"
                        showArrow={true}
                    />
                </div>
            </div>
        </div>
    );
};

CarFinanceCdpBanner.propTypes = {
    preApproved: PropTypes.bool,
    maxLoanAmount: PropTypes.number,
    firstName: PropTypes.string,
    pageSection: PropTypes.object,
    isPurposeBusiness: PropTypes.string,
    startPreApprovalOnFlyConnect: PropTypes.func,
    preApprovalOnFlyDesktop: PropTypes.object
};

export default CarFinanceCdpBanner;

